/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Базы данных товарных знаков РФ и WIPO
 * @export
 * @enum {string}
 */
export enum RegistryDatabase {
  Rutm = 'RUTM',
  Rutmap = 'RUTMAP',
  Wktm = 'WKTM',
  Mp = 'MP',
}

export function instanceOfRegistryDatabase(value: any): boolean {
  for (const key in RegistryDatabase) {
    if (Object.prototype.hasOwnProperty.call(RegistryDatabase, key)) {
      if (RegistryDatabase[key as keyof typeof RegistryDatabase] === value) {
        return true
      }
    }
  }
  return false
}

export function RegistryDatabaseFromJSON(json: any): RegistryDatabase {
  return RegistryDatabaseFromJSONTyped(json, false)
}

export function RegistryDatabaseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): RegistryDatabase {
  return json as RegistryDatabase
}

export function RegistryDatabaseToJSON(value?: RegistryDatabase | null): any {
  return value as any
}
